/* De labels van public.sites zoals het scherm SiteModal ze toont, op één plek
 * (F9.12). Een onbekende waarde komt er ongewijzigd uit, een lege zegt dat hij
 * leeg is. */

const TYPES: Record<string, string> = {
  office: 'Kantoor', warehouse: 'Magazijn', factory: 'Fabriek', retail: 'Winkel',
  batterijhub: 'Batterijhub', laadplein: 'Laadplein', vakantiepark: 'Vakantiepark', other: 'Anders',
};
const STATUSSEN: Record<string, string> = { active: 'Actief', inactive: 'Inactief', maintenance: 'Onderhoud' };

export const siteTypeLabel = (t: string | null | undefined) => (t ? TYPES[t] ?? t : 'Type niet ingevuld');
export const siteStatusLabel = (s: string | null | undefined) => (s ? STATUSSEN[s] ?? s : 'Status niet ingevuld');
